import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BrowserDashboardSvg = function BrowserDashboardSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.519 17.327h2.314v-1.47H5.52zM18.482 17.327h-2.315v-1.47h2.314zM11.26 10.163v2.296h1.48v-2.296zM8.236 13.897l-1.39-1.377 1.048-1.04 1.39 1.378zM12.06 17.57l5.094-5.05-1.048-1.04-5.093 5.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 3h20v18H2zm1.481 1.47v2.203h17.037V4.47zm0 15.06V8.144h17.037V19.53z",
    clipRule: "evenodd"
  }));
};
export var BrowserDashboard = function BrowserDashboard(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BrowserDashboardSvg
  }));
};